import React, { useState, useEffect } from "react";
import "./Carousel.css";

const Carousel = ({ banners, autoPlayInterval = 4000, onOrderNow }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % banners.length);
    }, autoPlayInterval);

    return () => clearInterval(interval);
  }, [banners.length, autoPlayInterval]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="hero-carousel">
      <div className="carousel-container">
        {banners.map((banner, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentIndex ? "active" : ""}`}
            style={{
              backgroundImage: `linear-gradient(135deg, ${banner.color}20, ${banner.color}40), url(${banner.img})`,
            }}>
            <div className="slide-content">
              {banner.badge && (
                <span className="slide-badge">{banner.badge}</span>
              )}
              <h2>{banner.title}</h2>
              <p>{banner.desc}</p>
              <button
                className="btn-primary"
                onClick={() => onOrderNow?.(banner)}>
                Order Now →
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="carousel-dots">
        {banners.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
